import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

export interface DataSource {
  name: string;
  date: string;
}

@Component({
  selector: 'app-data-sources',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule
  ],
  templateUrl: './data-sources.component.html',
  styleUrls: ['./data-sources.component.scss']
})
export class DataSourcesComponent {
  @Input() sources: DataSource[] = [];
}
